/**
 * Shared application constants.
 *
 * COUNTY_OF_ARREST_OPTIONS must match the ValidCountiesOfArrest set defined in
 * COJ.SAO4.DUIFO.Data/DataConstants.cs exactly. If the backend list changes,
 * update both files together.
 */

export const COUNTY_OF_ARREST_OPTIONS = ['Clay', 'Duval', 'Nassau', 'Unsure'];
